import type { TFunction } from 'i18next';

/**
 * Перекладає елемент довідника за i18n_key.
 * Якщо ключ порожній або перекладу немає — повертає назву з БД.
 */
export const tDirName = (
    t: TFunction,
    i18nKey?: string | null,
    fallbackName?: string | null,
): string => {
    const fallback = String(fallbackName ?? '');
    const key = String(i18nKey || '').trim();
    if (!key) return fallback;
    return String(t(key, { defaultValue: fallback }));
};
